import { configureStore } from '@reduxjs/toolkit';
import { appSlice } from '../components/app/useApp';

export default configureStore({
	reducer: {
		app: appSlice.reducer
	}
});
